import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { AiPrintoutLabels } from "../downloads/aiPrintout/contract";

/** The words a custom printout template prints, in the viewer's language. Reuses the app's own terms where they exist. */
export const useAiPrintoutLabels = (): AiPrintoutLabels => {
	const { t } = useTranslation();
	return useMemo(
		() => ({
			title: t("Daily Schedule"),
			scheduled: t("scheduled"),
			actual: t("actual"),
			location: t("printout.column.location"),
			name: t("printout.column.name"),
			certification: t("printout.column.certification"),
			role: t("printout.column.role"),
			job: t("printout.column.job"),
			floor: t("printout.column.floor"),
			shiftTime: t("printout.field.shiftTime"),
			hours: t("printout.column.scheduledHours"),
			notes: t("printout.column.notes"),
			charge: t("charge"),
			agency: t("agency"),
			open: t("open.shift"),
			pendingChange: t("printout.custom.ai.label.pending.change"),
			pendingDelete: t("printout.custom.ai.label.pending.delete"),
			timeOff: t("time.off"),
			callOuts: t("printout.custom.ai.label.call.outs"),
			calledAt: t("printout.custom.ai.label.called.at"),
			reason: t("reason"),
			source: t("source"),
			noJob: t("locations.job.unassigned"),
			noRole: t("printout.custom.ai.label.no.role"),
			anyRole: t("printout.custom.ai.label.any.role"),
			noStaff: t("printout.custom.ai.label.no.staff"),
			census: t("Census"),
			hppd: t("printout.custom.ai.label.hppd"),
			dhppd: t("printout.custom.ai.label.dhppd"),
			nhppd: t("printout.custom.ai.label.nhppd"),
			ppd: t("printout.custom.ai.label.ppd"),
			nursingHours: t("printout.custom.ai.label.nursing.hours"),
			laborCost: t("labor.cost"),
			target: t("schedule.vs.actual.target"),
			required: t("schedule.template.required"),
			actualHours: t("printout.custom.ai.label.actual.hours"),
			missingPunchIn: t("badge.missing.punch.in"),
			missingPunchOut: t("badge.missing.punch.out"),
			noPunch: t("actual.section.no.punch"),
			notScheduled: t("actual.section.not.scheduled"),
			notOnboarded: t("printout.custom.ai.label.not.onboarded"),
			otherTimeGroup: t("printout.custom.unmatched.tab"),
		}),
		[t],
	);
};
